import React, { forwardRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import cx from 'clsx';

import { Radio, RadioProps } from '../Radio/Radio';

import styles from './Toggle.module.scss';

export type ToggleProps = Omit<RadioProps, 'size'> & {
  size?: 'sm' | 'md' | '';
};

/**
 * This component represents a toggle.
 * This is extension of Radio component, so it is better to address
 * `Radio` documentation for more details.
 */
export const Toggle = forwardRef<HTMLInputElement, ToggleProps>(
  ({ className, size = '', children, ...radioProps }, ref) => (
    <Radio
      {...radioProps}
      className={cx(className, size && styles[`toggle--${size}`])}
      ref={ref}
      styles={styles}
      type="toggle"
      customMark={<FontAwesomeIcon icon="circle" />}
    >
      {children}
    </Radio>
  )
);

Toggle.displayName = 'Toggle';
